const checkUrl = (path: string) =>
  path.startsWith("https://") || path.startsWith("http://")
    ? path
    : "https://".concat(path);

export default checkUrl;
